$(document).ready(function() {

    let radioButtonListCommentType;
    let radioButtonListRatting;
    let radioButtonListCarType;
    let form;
    let submitButton;
    let errorMsg;
    let starsList;
    let checkboxAgreeDataUse1;

    // default for inputs
    const radioButtonCommentTypeDefaultValueChecked = '1';
    const radioButtonCarTypeDefaultValueChecked = '0';

    // init variables
    const init = () => {
        radioButtonListCommentType = $("input[type='radio'][name='typeComment']");
        radioButtonListRatting = $("input[type='radio'][name='rating']");
        radioButtonListCarType = $("input[type='radio'][name='boughtCar']");
        form = $("#feedbackForm");
        submitButton = $("#feedbackSubmitButton");
        errorMsg = $('#feedback-form-error');
        starsList = $('.fa.fa-star-o.fa-2x.rating-star');
        checkboxAgreeDataUse1 = $("input[type='checkbox'][name='agreeDataUse1']").first();
    }

    // set default values for input fields
    const setDefaultValues = () => {
        radioButtonListCommentType.each((index, item) => {
            if(item.value == radioButtonCommentTypeDefaultValueChecked) item.checked = true;
        });

        radioButtonListCarType.each((index, item) => {
            if(item.value == radioButtonCarTypeDefaultValueChecked) item.checked = true;
        });

        setDisabledSubmitButton(true);
        checkboxAgreeDataUse1.prop('checked', false);
    }

    // change submitButton state
    const setDisabledSubmitButton = (flag) => {
        if(flag == true) {
            submitButton.attr('disabled', 'disabled');
        } else {
            submitButton.removeAttr('disabled');
        }
    }

    // show error msg
    const showError = (flag) => {
        if(flag) {
            errorMsg.show();
        } else {
            errorMsg.hide();
        }
    }

    // filling stars according chosen radio
    const fillBackgroundRatingStarts = (rating) => {
        starsList.each((index, item) => {
            if(item.dataset.value <= rating) {
                item.classList.remove('fa-star-o');
                item.classList.add('fa-star');
                item.style.color = $('.feedback-form-star-rating-container').first().css("color");

            } else {
                item.classList.remove('fa-star');
                item.classList.add('fa-star-o');
                item.style.removeProperty('color');
            }
        });
    }

    init();
    setDefaultValues();

    submitButton.click(() => {
        form.submit();
    });

    form.on("submit", function (ev) {
        ev.preventDefault();
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: function (data) {
                window.location.reload();
            },
           error: function (xhr, status, errorThrown) {
              showError(true);
           }
        });
    });

    radioButtonListRatting.each((index, item) => {
        item.addEventListener('change', () => {
            if(item.checked) fillBackgroundRatingStarts(item.value);
        });
    });

    checkboxAgreeDataUse1.change(() => {
        setDisabledSubmitButton(!checkboxAgreeDataUse1.prop('checked'));
    });

});
